import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../select";
import { Input } from "../../input";
import { URLInput } from "../../url-input";

import type { ToolDependencyFormField } from "./types";

const TOOL_DEPENDENCY_FIELD_INPUT_CLASS = "h-9 text-xs";

export interface OpenaiYamlToolDependencyFieldInputProps {
  field: ToolDependencyFormField;
  inputId: string;
  value: string;
  readOnly?: boolean;
  onValueChange: (value: string) => void;
}

export const OpenaiYamlToolDependencyFieldInput = ({
  field,
  inputId,
  value,
  readOnly = false,
  onValueChange,
}: OpenaiYamlToolDependencyFieldInputProps) => {
  switch (field.inputType) {
    case "url":
      return (
        <URLInput
          id={inputId}
          value={value}
          readOnly={readOnly}
          onChange={onValueChange}
          placeholder={field.placeholder}
          classNameInput={TOOL_DEPENDENCY_FIELD_INPUT_CLASS}
        />
      );
    case "select":
      if (!field.options) {
        return (
          <Input
            id={inputId}
            value={value}
            disabled={readOnly}
            onChange={e => onValueChange(e.target.value)}
            placeholder={field.placeholder}
            className={TOOL_DEPENDENCY_FIELD_INPUT_CLASS}
          />
        );
      }
      return (
        <Select value={value} onValueChange={onValueChange} disabled={readOnly}>
          <SelectTrigger id={inputId} className={TOOL_DEPENDENCY_FIELD_INPUT_CLASS}>
            <SelectValue placeholder={field.placeholder} />
          </SelectTrigger>
          <SelectContent>
            {field.options.map(option => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    case "text":
    default:
      return (
        <Input
          id={inputId}
          value={value}
          disabled={readOnly || Boolean(field.disabled)}
          onChange={e => onValueChange(e.target.value)}
          placeholder={field.placeholder}
          className={TOOL_DEPENDENCY_FIELD_INPUT_CLASS}
        />
      );
  }
};
